import { render, staticRenderFns } from "./FormRadioBasic.vue?vue&type=template&id=0569336a"
import script from "./FormRadioBasic.vue?vue&type=script&lang=js"
export * from "./FormRadioBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports